/* tslint:disable */
/* eslint-disable */
export enum PartnerCalculationModelEnum {
  PercentageCut = 'PercentageCut',
  VarenrOnServiceabonnement = 'VarenrOnServiceabonnement',
  PartnerDeterminedPrice = 'PartnerDeterminedPrice'
}
